import axios from 'axios';

const SCHEDULE_API_URL = '/api/schedule';

/** 일정 첨부/참석자 조회 */
export const getScheduleExtras = async (id, token) => {
  const response = await axios.get(`${SCHEDULE_API_URL}/${id}/extras`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  return response.data;
};

/** 일정 등록 */
export const createSchedule = async (scheduleData, token) => {
  try {
    const response = await axios.post(SCHEDULE_API_URL, scheduleData, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    console.error("▶ createSchedule 오류:", error.response?.data || error.message);
    throw error;
  }
};

/** 일정 수정 */
export const updateSchedule = async (data, id, token) => {
  const response = await axios.put(`${SCHEDULE_API_URL}/${id}`, data, {
    headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }
  });
  return response.data;
};

/** 일정 삭제 */
export const deleteSchedule = async (id, token) => {
  const response = await axios.delete(`${SCHEDULE_API_URL}/${id}`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  return response.data;
};

/** 일정 단건 조회 */
export const getScheduleById = async (id, token) => {
  const response = await axios.get(`${SCHEDULE_API_URL}/${id}`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  return response.data;
};

/** 일정 조회 - Calendar */
export const getScheduleCalendar = async (viewtype, params, token) => {
  const response = await axios.get(`${SCHEDULE_API_URL}/calendar`, {
    headers: { Authorization: `Bearer ${token}` },
    params: { viewtype, ...params }
  });
  return response.data;
};

/** 일정 조회 - List */
export const getScheduleList = async (params, token) => {
  const response = await axios.get(`${SCHEDULE_API_URL}/list`, {
    headers: { Authorization: `Bearer ${token}` },
    params,
  });
  return response.data;
};

/** 일정 승인 */
export const approveSchedule = async (id, token, status) => {
  const response = await axios.post(
    `${SCHEDULE_API_URL}/${id}/approve`,
    { status }, // ✅ 인자로 받은 상태값 전달
    { headers: { Authorization: `Bearer ${token}` } }
  );
  return response.data;
};

/** 일정 반려 */
export const rejectSchedule = async (id, token, status) => {
  const response = await axios.post(
    `${SCHEDULE_API_URL}/${id}/reject`,
    { status }, // ✅ 인자로 받은 상태값 전달
    { headers: { Authorization: `Bearer ${token}` } }
  );
  return response.data;
};

/** 일정 회수 */
export const recallSchedule = async (id, token, status) => {
  const response = await axios.post(
    `${SCHEDULE_API_URL}/${id}/recall`,
    { status }, // ✅ 인자로 받은 상태값 전달
    { headers: { Authorization: `Bearer ${token}` } }
  );
  return response.data;
};

/** 부서 참석자 확장 */
export async function expandParticipantsForMeeting(participants, token) {
  const expanded = [];

  for (const p of participants) {
    if (p.target_type === 'dept') {
      try {
        const res = await axios.get(`${SCHEDULE_API_URL}/departments/${p.target_id}/users`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        const users = res.data;

        if (Array.isArray(users)) {
          users.forEach(u => {
            const alreadyExists = participants.some(
              existing =>
                existing.target_type === 'user' && existing.target_id === u.userid
            );
            if (!alreadyExists) {
              expanded.push({
                target_from: p.target_from,
                target_type: "user",
                target_id: u.userid,
                target_name: u.name,
                disp_target_name: `${u.name} / ${u.position} (${u.dept_name})`
              });
            }
          });
        }
      } catch (err) {
        console.error("부서 사용자 조회 실패:", err);
      }
    } else {
      expanded.push({
        ...p,
        disp_target_name:
          p.disp_target_name || p.full_dept_name || p.dept_name || p.target_name
      });
    }
  }
  return expanded;
}

/** 참석 여부 업데이트 */
export const updateAttendance = async (id, status, token, targetId) => {
  const response = await axios.put(
    `${SCHEDULE_API_URL}/${id}/attendance/status`,
    { status, target_id: targetId }, // ✅ target_id 추가
    { headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' } }
  );
  return response.data;
};

/** 참석자 목록 조회 */
export const getAttendanceList = async (id, token) => {
  const response = await axios.get(`${SCHEDULE_API_URL}/${id}/attendance`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  return response.data;
};

/** 메일 발송 */
export const sendMail = async (id, token) => {
  const response = await axios.post(`${SCHEDULE_API_URL}/${id}/sendMail`, {}, {
    headers: { Authorization: `Bearer ${token}` }
  });
  return response.data;
};

/** 일정 파일 업로드 (최종 수정된 엔드포인트) */
export const uploadScheduleFiles = async (id, formData, token) => {
  const response = await axios.post(`${SCHEDULE_API_URL}/${id}/uploadFiles`, formData, {
    headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'multipart/form-data' }
  });
  return response.data;
};

/** 메일 발송 취소 */
export const cancelMail = async (id, token) => {
  const response = await axios.post(`${SCHEDULE_API_URL}/${id}/cancelMail`, {}, {
    headers: { Authorization: `Bearer ${token}` }
  });
  return response.data;
};
